import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    home: "Home",
    aboutUs: "About Us",
    ourFarms: "Our Farms",
    products: "Products",
    qualitySafety: "Quality & Safety",
    sustainability: "Sustainability",
    contact: "Contact",
    
    // Home Page
    heroTitle: "Premium Quality Meats",
    heroSubtitle: "From Our Farm to Your Table",
    heroDescription: "Experience the finest cuts of meat, ethically sourced and delivered fresh to your doorstep.",
    viewProducts: "View Products",
    contactUs: "Contact Us",
    shopByCategory: "Shop by Category",
    exploreRange: "Explore our wide range of premium meat products and specialty items",
    viewAllProducts: "View All Products",
    whyChooseUs: "Why Choose EliteMeat?",
    whyChooseDesc: "We're committed to providing the highest quality meat products with exceptional service",
    farmFresh: "Farm Fresh",
    farmFreshDesc: "Direct from our farms to your table, ensuring maximum freshness",
    premiumQuality: "Premium Quality",
    premiumQualityDesc: "Only the finest cuts selected by our expert butchers",
    fastDelivery: "Fast Delivery",
    fastDeliveryDesc: "Same-day delivery across Egypt for ultimate convenience",
    halal: "100% Halal",
    halalDesc: "All products are certified halal and ethically sourced",
    customerReviews: "What Our Customers Say",
    reviewsDesc: "Trusted by restaurants, hotels, and families across Egypt",
    
    // Products Page
    ourProducts: "Our Products",
    productsSubtitle: "Premium quality meat products for every need",
    all: "All",
    beefMeat: "Beef Meat",
    eliteBeefSteaks: "Elite Beef Steaks",
    lambMeat: "Lamb Meat",
    homemadeProducts: "Homemade Products",
    smoked: "Smoked",
    addToCart: "Add to Cart",
    viewDetails: "View Details",
    
    // Product Detail
    specifications: "Specifications",
    origin: "Origin",
    freshness: "Freshness",
    storage: "Storage",
    weight: "Weight",
    packaging: "Packaging",
    cutType: "Cut Type",
    quantity: "Quantity",
    customerReviewsTitle: "Customer Reviews",
    writeReview: "Write a Review",
    productNotFound: "Product Not Found",
    backToProducts: "Back to Products",
    productSpecifications: "Product Specifications",
    selectWeight: "Select Weight",
    selectCutType: "Select Cut Type",
    selectPackaging: "Select Packaging",
    unitPrice: "Unit Price",
    totalPrice: "Total Price",
    pleaseSelectAllOptions: "Please select all options",
    optionsRequired: "Weight, cut type, and packaging are required",
    reviewSubmitted: "Review submitted!",
    thankYouFeedback: "Thank you for your feedback",
    yourName: "Your Name",
    enterYourName: "Enter your name",
    rating: "Rating",
    yourReview: "Your Review",
    shareExperience: "Share your experience with this product",
    submitReview: "Submit Review",
    noReviewsYet: "No reviews yet. Be the first to review this product!",
    verifiedPurchase: "Verified Purchase",
    review: "review",
    reviews: "reviews",
    productNotFound: "Product not found",
    backToProducts: "Back to Products",
    productSpecifications: "Product Specifications",
    selectWeight: "Select Weight",
    selectCutType: "Select Cut Type",
    selectPackaging: "Select Packaging",
    unitPrice: "Unit Price",
    totalPrice: "Total Price",
    pleaseSelectAllOptions: "Please select all options",
    optionsRequired: "Weight, cut type, and packaging are required",
    reviewSubmitted: "Review submitted!",
    thankYouFeedback: "Thank you for your feedback",
    yourName: "Your Name",
    enterYourName: "Enter your name",
    rating: "Rating",
    yourReview: "Your Review",
    shareExperience: "Share your experience with this product",
    submitReview: "Submit Review",
    noReviewsYet: "No reviews yet. Be the first to review this product!",
    verifiedPurchase: "Verified Purchase",
    review: "Review",
    reviews: "Reviews",
    
    // Cart
    shoppingCart: "Shopping Cart",
    emptyCart: "Your cart is empty",
    startShopping: "Start Shopping",
    continueShopping: "Continue Shopping",
    proceedToCheckout: "Proceed to Checkout",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    freeShipping: "Free",
    total: "Total",
    remove: "Remove",
    
    // Checkout
    checkout: "Checkout",
    customerInfo: "Customer Information",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    address: "Delivery Address",
    city: "City",
    notes: "Order Notes (Optional)",
    paymentMethod: "Payment Method",
    cashOnDelivery: "Cash on Delivery",
    visaCard: "Visa / Credit Card",
    cardNumber: "Card Number",
    expiryDate: "Expiry Date",
    cvv: "CVV",
    placeOrder: "Place Order via WhatsApp",
    orderConfirmation: "Order will be confirmed via WhatsApp",
    
    // Footer
    footerAbout: "Premium quality meats from our farm to your table. Committed to excellence in every cut.",
    quickLinks: "Quick Links",
    contactInfo: "Contact Info",
    allRightsReserved: "All rights reserved.",
    
    // Quality Page
    qualityTitle: "Quality & Safety",
    qualitySubtitle: "Our commitment to excellence and your health",
    ourPractices: "Our Farming Practices",
    
    // Common
    egp: "EGP",
    loading: "Loading...",
    error: "Error",
    success: "Success",
  },
  ar: {
    // Navigation
    home: "الرئيسية",
    aboutUs: "من نحن",
    ourFarms: "مزارعنا",
    products: "المنتجات",
    qualitySafety: "الجودة والسلامة",
    sustainability: "الاستدامة",
    contact: "اتصل بنا",
    
    // Home Page
    heroTitle: "لحوم عالية الجودة",
    heroSubtitle: "من مزرعتنا إلى مائدتك",
    heroDescription: "استمتع بأجود قطع اللحوم، من مصادر أخلاقية وتُسلم طازجة إلى باب منزلك.",
    viewProducts: "عرض المنتجات",
    contactUs: "اتصل بنا",
    shopByCategory: "تسوق حسب الفئة",
    exploreRange: "اكتشف مجموعتنا الواسعة من منتجات اللحوم الفاخرة والمنتجات المميزة",
    viewAllProducts: "عرض جميع المنتجات",
    whyChooseUs: "لماذا تختار إيليت ميت؟",
    whyChooseDesc: "نحن ملتزمون بتقديم منتجات اللحوم عالية الجودة مع خدمة استثنائية",
    farmFresh: "طازج من المزرعة",
    farmFreshDesc: "مباشرة من مزارعنا إلى مائدتك، لضمان أقصى درجات النضارة",
    premiumQuality: "جودة ممتازة",
    premiumQualityDesc: "فقط أجود القطع المختارة من قبل جزارينا الخبراء",
    fastDelivery: "توصيل سريع",
    fastDeliveryDesc: "توصيل في نفس اليوم في جميع أنحاء مصر",
    halal: "حلال 100%",
    halalDesc: "جميع المنتجات معتمدة حلال ومن مصادر أخلاقية",
    customerReviews: "ماذا يقول عملاؤنا",
    reviewsDesc: "موثوق به من قبل المطاعم والفنادق والعائلات في جميع أنحاء مصر",
    
    // Products Page
    ourProducts: "منتجاتنا",
    productsSubtitle: "منتجات لحوم عالية الجودة لكل احتياج",
    all: "الكل",
    beefMeat: "لحم بقري",
    eliteBeefSteaks: "ستيك بقري فاخر",
    lambMeat: "لحم ضأن",
    homemadeProducts: "منتجات منزلية",
    smoked: "مدخن",
    addToCart: "أضف إلى السلة",
    viewDetails: "عرض التفاصيل",
    
    // Product Detail
    specifications: "المواصفات",
    origin: "المصدر",
    freshness: "الطزاجة",
    storage: "التخزين",
    weight: "الوزن",
    packaging: "التغليف",
    cutType: "نوع القطع",
    quantity: "الكمية",
    customerReviewsTitle: "آراء العملاء",
    writeReview: "اكتب مراجعة",
    productNotFound: "المنتج غير موجود",
    backToProducts: "العودة للمنتجات",
    productSpecifications: "مواصفات المنتج",
    selectWeight: "اختر الوزن",
    selectCutType: "اختر نوع القطع",
    selectPackaging: "اختر التغليف",
    unitPrice: "سعر الوحدة",
    totalPrice: "السعر الإجمالي",
    pleaseSelectAllOptions: "يرجى اختيار جميع الخيارات",
    optionsRequired: "الوزن ونوع القطع والتغليف مطلوبة",
    reviewSubmitted: "تم إرسال المراجعة!",
    thankYouFeedback: "شكراً لملاحظاتك",
    yourName: "اسمك",
    enterYourName: "أدخل اسمك",
    rating: "التقييم",
    yourReview: "مراجعتك",
    shareExperience: "شارك تجربتك مع هذا المنتج",
    submitReview: "إرسال المراجعة",
    noReviewsYet: "لا توجد مراجعات بعد. كن أول من يراجع هذا المنتج!",
    verifiedPurchase: "عملية شراء موثقة",
    review: "مراجعة",
    reviews: "مراجعات",
    
    // Cart
    shoppingCart: "سلة التسوق",
    emptyCart: "سلة التسوق فارغة",
    startShopping: "ابدأ التسوق",
    continueShopping: "متابعة التسوق",
    proceedToCheckout: "متابعة الدفع",
    orderSummary: "ملخص الطلب",
    subtotal: "المجموع الفرعي",
    shipping: "الشحن",
    freeShipping: "مجاني",
    total: "الإجمالي",
    remove: "إزالة",
    
    // Checkout
    checkout: "إتمام الطلب",
    customerInfo: "معلومات العميل",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    address: "عنوان التوصيل",
    city: "المدينة",
    notes: "ملاحظات الطلب (اختياري)",
    paymentMethod: "طريقة الدفع",
    cashOnDelivery: "الدفع عند الاستلام",
    visaCard: "فيزا / بطاقة ائتمان",
    cardNumber: "رقم البطاقة",
    expiryDate: "تاريخ الانتهاء",
    cvv: "CVV",
    placeOrder: "إرسال الطلب عبر واتساب",
    orderConfirmation: "سيتم تأكيد الطلب عبر واتساب",
    
    // Footer
    footerAbout: "لحوم عالية الجودة من مزرعتنا إلى مائدتك. ملتزمون بالتميز في كل قطعة.",
    quickLinks: "روابط سريعة",
    contactInfo: "معلومات الاتصال",
    allRightsReserved: "جميع الحقوق محفوظة.",
    
    // Quality Page
    qualityTitle: "الجودة والسلامة",
    qualitySubtitle: "التزامنا بالتميز وصحتك",
    ourPractices: "ممارساتنا الزراعية",
    
    // Common
    egp: "ج.م",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجاح",
  }
};

// Arabic product names mapping
export const productNamesAr = {
  "Fillet Red Casserole Cubes": "كباب حله احمر",
  "Fillet Cubes": "مكعبات فيليه",
  "Stewing Cubes": "مكعبات خضار",
  "Stewing Cubes Fat": "مكعبات خضار دهن ",
  "Shin Beef": "موزة بقري",
  "Osso Bucco": "أوسو بوكو",
  "Osso Bucco Piece": "قطعة أوسو بوكو",
  "Piccata": "بيكاتا",
  "Escalope": "اسكالوب",
  "Beef Shabu Shabu": "شرائح لحم رفيعه",
  "Shawerma": "شاورما",
  "Marinated Shawerma": "شاورما متبله",
  "Beef Stroganoff": "ستروجانوف بقري",
  "Ground Beef Red": "لحم مفروم أحمر",
  "Ground Beef Low Fat": "لحم مفروم دهن قليل",
  "Ground Beef Medium": "لحم مفروم متوسط",
  "Liver": "كبدة بقرى",
  "Heart": "قلب بقرى",
  "Kidney": "كلاوي بقرى ",
  "Oxtail": "عكاوى",
  "Beef Marrow Bone": "مواسير بالنخاع",
  "Beef Meat": "لحم بقري",
  "Trotter Pieces": "قطع كوارع",
  "Beef Brain": "مخ بقري",
  "Beef Spleen": "طحال بقري",
  "Testicles": "مخاصي",
  "Beef Burger": "برجر ",
  "Smoked Beef Burger": "برجر مدخن",
  "Cheese Burger": "برجر جبنه",
  "Sausage": "سجق",
  "Hot Sausage": "سجق حار",
  "Smoked Sausage": "سجق مدخن",
  "Meat Balls": "كفتة داوود باشا",
  "Grill Kofta": "كفتة شوى",
  "Rice Kofta": "كفتة ارز",
  "Hawawshi Meat": "حواوشى لحمة",
  "Hawawshi Bread (2 pieces)": "حواوشي بالعيش (قطعتين)",
  "Hawawshi Cheese": "حواوشي بالجبنة",
  "Beef Schnitzel Bread Crumbs": "بفتيك بقسماط",
  "Eye Round Roast": "عرق تريبيانكو ",
  "Bottom Round Roast": "عرق ضهر الفخدة",
  "Picanha Joint": "عرق بيكانيا/ بالقطعة",
  "Red Fillet Roast": "عرق فلتو / بالقطعة",
  "Full Fillet Roast with Minced Meat": "عرق فلتو كامل بالمفروم و التوضيب / بالقطعة",
  "Beef Shank Roast": "عرق موزه بالعظم / بالقطعة",
  "Short Ribs Whole": "شورت ريبس كاملة/ بالقطعة",
  "Short Ribs Pieces": "قطع شورت ريبس",
  "Brisket": "بريسكت",
  "Brisket Roll": "بريسكت رول كاملة/ بالقطعة",
  "Sirloin Tip Steak": "ستيك سمانة خارجية",
  "Sirloin Center Steak": "ستيك سمانة داخلية",
  "Strip Loin Steak": "أنتركوت ستيك",
  "Strip Loin Steak Piece": "قطعة ستيك ستريب لوين",
  "New York Steak": "ستيك نيويورك",
  "Fillet Steak": "ستيك فيليه",
  "Fillet Steak Piece": "قطعة ستيك فيليه",
  "T-Bone Steak": " تي بون ستيك",
  "Ribeye Steak": " ريب آي ستيك",
  "Tomahawk Steak": " توماهوك ستيك",
  "Flank Steak": "فلانك ستيك",
  "Lamb Sausages": "سجق ضاني",
  "Lamb Meatballs": "كفتة داود باشا ضاني",
  "Lamb Kofta": "كفتة ضاني",
  "Lamb Tarp Kofta": "كفتة طرب",
  "Lamb Leg": "فخذة ضاني",
  "Lamb Leg Boneless": "فخذة ضاني مشفي",
  "Lamb Leg Steak": "ستيك فخذة ضاني",
  "Lamb Shoulder Boneless": "كتف مشفي ضاني",
  "Lamb Fats": "لية ضاني",
  "Lamb Shoulder": "كتف ضاني كامل بالعظم",
  "Ground Lamb": "مفروم ضاني",
  "Lamb Neck": "رقبة ضاني",
  "Lamb Shank": "موزة ضاني",
  "Lamb T-Bone": "بيت كلاوي ضانى",
  "Lamb Cubes": "كباب حلة ضاني",
  "Lamb Chops": "ريش ضاني",
  "Vine Leaves": "ورق عنب",
  "Mombar": "ممبار",
  "Minced Meat Kobeba": "كبيبة لحم مفروم",
  "Meat Sambusak": "سمبوسك لحم",
  "Mix Cheese Sambusak": "سمبوسك جبن مشكل",
  "Bashamel": "بشاميل",
  "Smoked Ribeye Piece": "قطعة ريب آي مدخن",
  "Smoked Ribeye Whole": "ريب آي مدخن كامل",
  "Smoked Burger": "برجر مدخن",
  "Smoked Sausages": "سجق مدخن",
  "Smoked Short Ribs": "ضلوع قصيرة مدخنة",
  "Smoked Brisket": "بريسكت مدخن"
};

// Category names in Arabic
export const categoryNamesAr = {
  "Beef Meat": "لحم بقري",
  "Elite Beef Steaks": "ستيك بقري فاخر",
  "Lamb Meat": "لحم ضأن",
  "Homemade Products": "منتجات منزلية",
  "Smoked": "مدخن"
};

// Cut types in Arabic
export const cutTypesAr = {
  "Cubed": "مكعبات",
  "Bone-In": "بالعظم",
  "Boneless": "بدون عظم",
  "Cross-Cut": "قطع عرضي",
  "Individual Piece": "قطعة فردية",
  "Thin Slices": "شرائح رفيعة",
  "Flattened": "مفلطح",
  "Paper-Thin Slices": "شرائح رقيقة جداً",
  "Sliced": "شرائح",
  "Sliced and Marinated": "شرائح متبلة",
  "Strips": "شرائط",
  "Ground": "مفروم",
  "Whole": "كامل",
  "Halved": "نصف",
  "Pieces": "قطع",
  "Split": "مشقوق",
  "Cleaned": "منظف",
  "Classic Patty": "قرص كلاسيكي",
  "Smoked Patty": "قرص مدخن",
  "Stuffed Patty": "قرص محشي",
  "Links": "حلقات",
  "Traditional": "تقليدي",
  "On Skewers": "على أسياخ",
  "Loose": "سائب",
  "Mixed": "مخلوط",
  "Ground and Seasoned": "مفروم ومتبل",
  "Stuffed": "محشي",
  "Stuffed with Cheese": "محشي بالجبنة",
  "Breaded": "بالبقسماط",
  "Whole Joint": "قطعة كاملة",
  "Rolled": "ملفوف",
  "Whole Rack": "ريش كاملة",
  "Cut Pieces": "قطع مقطعة",
  "Whole Steak": "ستيك كامل",
  "Center Cut": "قطع وسط",
  "Individual Steak": "ستيك فردي",
  "Meatballs": "كرات لحم",
  "Fat-Wrapped": "ملفوف بالدهن",
  "Steak Cut": "قطع ستيك",
  "Diced": "مكعبات صغيرة",
  "T-Bone Cut": "قطع تي بون",
  "Single Chops": "ريش فردية",
  "French Rack": "ريش فرنسية",
  "Ready to Cook": "جاهز للطبخ",
  "Ready to Fry": "جاهز للقلي",
  "With Long Bone": "بالعظم الطويل",
  "Flat Cut": "قطع مسطح",
  "Point Cut": "قطع مدبب",
  "Ground Kofta": "كفتة مفرومة"
};

// Packaging options in Arabic
export const packagingOptionsAr = {
  "Vacuum Sealed": "مفرغ من الهواء",
  "Fresh Pack": "أطباق فوم",
  "Freezer Pack": "تغليف للتجميد"
};

// Specification keys in Arabic
export const specificationKeysAr = {
  "origin": "المصدر",
  "freshness": "الطزاجة",
  "storage": "التخزين",
  "shelfLife": "مدة الصلاحية",
  "bestUse": "أفضل استخدام",
  "fatContent": "نسبة الدهون",
  "marinated": "متبل",
  "preparation": "التحضير",
  "spiceLevel": "مستوى التوابل",
  "ingredients": "المكونات",
  "spiced": "متبل",
  "weight": "الوزن",
  "filling": "الحشوة",
  "contents": "المحتويات",
  "seasoned": "متبل",
  "coating": "التغليف",
  "aging": "التعتيق",
  "grade": "الدرجة",
  "cut": "القطع",
  "type": "النوع",
  "style": "الأسلوب",
  "seasoning": "التتبيل",
  "casings": "الأغلفة",
  "flavor": "النكهة"
};

// Specification values in Arabic
export const specificationValuesAr = {
  // Origin
  "EliteMeat Farms, Egypt": "مزارع إيليت ميت، مصر",
  // Freshness
  "Fresh daily": "طازج يومياً",
  "Made fresh daily": "يُصنع طازجاً يومياً",
  "Ground fresh daily": "يُفرم طازجاً يومياً",
  // Storage
  "Keep refrigerated at 0-4°C": "يُحفظ مبرداً عند ٠-٤ درجة مئوية",
  // Shelf Life
  "3-5 days refrigerated": "٣-٥ أيام مبرداً",
  // Best Use
  "Stewing, braising": "الطبخ البطيء، التحمير",
  "Slow cooking, stews": "الطبخ البطيء، اليخنات",
  "Braising, osso bucco": "التحمير، أوسو بوكو",
  "Individual portions": "حصص فردية",
  "Piccata, pan-frying": "بيكاتا، القلي",
  "Schnitzel, escalope": "شنيتزل، اسكالوب",
  "Shabu shabu, hot pot": "شابو شابو، القدر الساخن",
  "Shawerma": "شاورما",
  "Frying, grilling": "القلي، الشوي",
  "Grilling, slow cooking": "الشوي، الطبخ البطيء",
  "Stews, pies": "اليخنات، الفطائر",
  "Soups, kawarea": "الشوربات، الكوارع",
  "Frying": "القلي",
  "Traditional dishes": "الأطباق التقليدية",
  "BBQ, braising": "الشواء، التحمير",
  "Grilling, braising": "الشوي، التحمير",
  "Smoking, slow cooking": "التدخين، الطبخ البطيء",
  "Roasting": "التحميص",
  "Pot roast, braising": "اللحم المشوي، التحمير",
  "Roasting, deli slicing": "التحميص، التقطيع",
  "Slow roasting": "التحميص البطيء",
  "Braising, stewing": "التحمير، الطبخ البطيء",
  "Slow cooking, stewing": "الطبخ البطيء، اليخنات",
  "Grilling, stir-fry": "الشوي، القلي السريع",
  // Fat Content
  "Low fat": "قليل الدهون",
  "Extra low fat": "قليل الدهون جداً",
  "Medium": "متوسط",
  "Higher fat content": "نسبة دهون أعلى",
  // Marinated
  "Traditional spices": "توابل تقليدية",
  // Preparation
  "Pre-sliced strips": "شرائط مقطعة مسبقاً",
  "Smoked": "مدخن",
  "Cold smoked": "مدخن بارد",
  // Spice Level
  "Hot": "حار",
  // Ingredients
  "Beef, herbs, spices": "لحم بقري، أعشاب، توابل",
  // Spiced
  "Traditional kofta blend": "خلطة الكفتة التقليدية",
  // Weight
  "150g per patty": "١٥٠ جرام للقطعة",
  // Filling
  "Rice": "أرز",
  "Cheese": "جبنة",
  "Beef and cheese": "لحم وجبنة",
  "Meat and rice": "لحم وأرز",
  "Rice and meat": "أرز ولحم",
  "Minced meat": "لحم مفروم",
  "Seasoned meat": "لحم متبل",
  "Mixed cheese": "جبنة مشكلة",
  // Contents
  "2 pieces": "قطعتان",
  // Seasoned
  "Traditional hawawshi spices": "توابل الحواوشي التقليدية",
  // Coating
  "Bread crumbs": "بقسماط",
  // Aging
  "7-day aged": "معتق ٧ أيام",
  "14-day aged": "معتق ١٤ يوم",
  "21-day aged": "معتق ٢١ يوم",
  "28-day aged": "معتق ٢٨ يوم",
  // Grade
  "Premium Choice": "اختيار ممتاز",
  // Cut
  "Bone-in": "بالعظم",
  "Boneless": "بدون عظم",
  "Steak cut": "قطع ستيك",
  "T-bone": "تي بون",
  "Cubed": "مكعبات",
  "Chop/Rack": "ريش",
  "Bone-in, whole": "بالعظم، كامل",
  // Type
  "Pure lamb fat": "دهن ضأن نقي",
  // Style
  "Dawood Basha": "داود باشا",
  "Tarp (fat-wrapped)": "طرب (ملفوف بالدهن)",
  // Casings
  "Natural": "طبيعية",
  // Flavor
  "Rich smoky": "نكهة مدخنة غنية",
  // Fat Cap
  "Yes": "نعم",
  // Stuffed
  "Minced meat": "لحم مفروم"
};

// Product descriptions in Arabic
export const productDescriptionsAr = {
  "Premium fillet cubes for casseroles": "مكعبات فيليه فاخرة للطواجن",
  "Premium fillet cubes for stir-fry and stews": "مكعبات فيليه فاخرة للقلي السريع واليخنات",
  "Classic beef cubes for traditional stews": "مكعبات لحم بقري كلاسيكية لليخنات التقليدية",
  "Beef cubes with extra fat for rich flavor": "مكعبات لحم بقري بدهون إضافية لنكهة غنية",
  "Beef shin for slow cooking": "موزة بقري للطبخ البطيء",
  "Cross-cut beef shank for Italian classics": "ساق بقري مقطع عرضياً للأطباق الإيطالية الكلاسيكية",
  "Individual osso bucco pieces": "قطع أوسو بوكو فردية",
  "Thin beef slices for piccata": "شرائح لحم بقري رفيعة للبيكاتا",
  "Flattened beef cutlets": "قطع لحم بقري مفلطحة",
  "Paper-thin beef slices for hot pot": "شرائح لحم بقري رقيقة جداً للقدر الساخن",
  "Sliced beef for shawerma": "شرائح لحم بقري للشاورما",
  "Pre-marinated beef shawerma": "شاورما لحم بقري متبلة مسبقاً",
  "Pre-cut beef strips for stroganoff": "شرائط لحم بقري مقطعة مسبقاً للستروجانوف",
  "Lean ground beef": "لحم بقري مفروم قليل الدهون",
  "Extra lean ground beef": "لحم بقري مفروم قليل الدهون جداً",
  "Ground beef with balanced fat": "لحم بقري مفروم متوازن الدهون",
  "Fresh beef liver": "كبدة بقري طازجة",
  "Fresh beef heart": "قلب بقري طازج",
  "Fresh beef kidney": "كلاوي بقري طازجة",
  "Fresh oxtail for rich stews": "عكاوي طازجة لليخنات الغنية",
  "Marrow bones for cooking": "عظام بالنخاع للطبخ",
  "Beef trotter pieces": "قطع كوارع بقري",
  "Fresh beef brain": "مخ بقري طازج",
  "Fresh beef spleen": "طحال بقري طازج",
  "Traditional delicacy": "طبق تقليدي شهي",
  "Premium beef burger patties": "أقراص برجر بقري فاخرة",
  "Smoked beef burger patties": "أقراص برجر بقري مدخنة",
  "Beef burger with cheese filling": "برجر بقري بحشوة الجبنة",
  "Fresh beef sausages": "سجق بقري طازج",
  "Spicy beef sausages": "سجق بقري حار",
  "Smoked beef sausages": "سجق بقري مدخن",
  "Homemade beef meatballs": "كفتة داود باشا بقري منزلية",
  "Traditional grill kofta": "كفتة شوي تقليدية",
  "Kofta with rice filling": "كفتة بحشوة الأرز",
  "Seasoned meat for hawawshi": "لحم متبل للحواوشي",
  "Ready hawawshi with bread": "حواوشي جاهز بالعيش",
  "Hawawshi with cheese": "حواوشي بالجبنة",
  "Breaded beef schnitzel": "شنيتزل بقري بالبقسماط",
  "Lean eye round for roasting": "عين الفخذة قليلة الدهون للتحميص",
  "Economical cut for roasting": "قطعة اقتصادية للتحميص",
  "Brazilian-style picanha roast": "بيكانيا على الطريقة البرازيلية",
  "Premium fillet roast": "عرق فيليه فاخر",
  "Fillet roast stuffed with minced meat": "عرق فيليه محشي باللحم المفروم",
  "Whole beef shank for roasting": "موزة بقري كاملة للتحميص",
  "Whole short ribs rack": "شورت ريبس كاملة",
  "Cut short ribs pieces": "قطع شورت ريبس",
  "Whole beef brisket": "بريسكت بقري كامل",
  "Rolled beef brisket": "بريسكت بقري ملفوف",
  "Lean sirloin tip steak": "ستيك سمانة خارجية قليل الدهون",
  "Premium center-cut sirloin": "سمانة داخلية فاخرة",
  "Premium striploin steak": "ستيك ستريب لوين فاخر",
  "Individual striploin steak piece": "قطعة ستيك ستريب لوين فردية",
  "Classic New York strip steak": "ستيك نيويورك كلاسيكي",
  "Premium beef fillet steak": "ستيك فيليه بقري فاخر",
  "Individual fillet steak piece": "قطعة ستيك فيليه فردية",
  "Classic T-bone steak": "ستيك تي بون كلاسيكي",
  "Premium ribeye steak": "ستيك ريب آي فاخر",
  "Impressive tomahawk ribeye": "توماهوك ريب آي مميز",
  "Lean and flavorful flank": "فلانك قليل الدهون وشهي",
  "Traditional lamb sausages": "سجق ضاني تقليدي",
  "Premium lamb meatballs - Dawood Basha style": "كفتة ضاني فاخرة - على طريقة داود باشا",
  "Traditional Egyptian lamb kofta": "كفتة ضاني مصرية تقليدية",
  "Lamb kofta wrapped in lamb fat": "كفتة ضاني ملفوفة بدهن الضأن",
  "Whole lamb leg with bone": "فخذة ضاني كاملة بالعظم",
  "Boneless lamb leg": "فخذة ضاني بدون عظم",
  "Premium lamb leg steaks": "ستيك فخذة ضاني فاخر",
  "Boneless lamb shoulder": "كتف ضاني بدون عظم",
  "Premium lamb fat for cooking": "دهن ضاني فاخر للطبخ",
  "Whole lamb shoulder with bone": "كتف ضاني كامل بالعظم",
  "Premium ground lamb meat": "لحم ضاني مفروم فاخر",
  "Lamb neck for slow cooking": "رقبة ضاني للطبخ البطيء",
  "Premium lamb shank": "موزة ضاني فاخرة",
  "Premium lamb T-bone steaks": "ستيك تي بون ضاني فاخر",
  "Premium lamb cubes for stewing": "مكعبات ضاني فاخرة للطبخ",
  "Premium lamb chops": "ريش ضاني فاخرة",
  "Stuffed vine leaves": "ورق عنب محشي",
  "Traditional Egyptian mombar": "ممبار مصري تقليدي",
  "Traditional kobeba with minced meat": "كبيبة تقليدية باللحم المفروم",
  "Traditional meat sambusak": "سمبوسك لحم تقليدي",
  "Sambusak with mixed cheese": "سمبوسك بالجبنة المشكلة",
  "Individual smoked ribeye piece": "قطعة ريب آي مدخنة فردية",
  "Whole smoked ribeye": "ريب آي مدخن كامل",
  "Smoked beef burger": "برجر بقري مدخن",
  "Smoked sausages": "سجق مدخن",
  "Smoked short ribs": "شورت ريبس مدخنة",
  "Smoked brisket": "بريسكت مدخن"
};

// Weight translations in Arabic
export const weightTranslationsAr = {
  "500g": "٥٠٠ جم",
  "1kg": "١ كجم",
  "1.5kg": "١.٥ كجم",
  "2kg": "٢ كجم",
  "2.5kg": "٢.٥ كجم",
  "3kg": "٣ كجم",
  "3.5kg": "٣.٥ كجم",
  "4kg": "٤ كجم",
  "4.5kg": "٤.٥ كجم",
  "5kg": "٥ كجم",
  "Per Piece": "للقطعة",
  "per piece": "للقطعة",
  "2 Pieces": "قطعتان",
  "4 Pieces": "٤ قطع",
  "6 Pieces": "٦ قطع",
  "10 pieces": "١٠ قطع",
  "Dish 500g": "طبق ٥٠٠ جم",
  "Dish 1kg": "طبق ١ كجم",
  "12 Pieces": "١٢ قطعة",
  "24 Pieces": "٢٤ قطعة"
};

// Convert number to Arabic numerals
export const toArabicNumerals = (num) => {
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return String(num).replace(/[0-9]/g, (d) => arabicNumerals[parseInt(d)]);
};

// Format price in Arabic
export const formatPriceArabic = (price) => {
  if (price === undefined || price === null) return '٠';
  const formatted = price.toLocaleString('en-US');
  return toArabicNumerals(formatted);
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ar');

  useEffect(() => {
    // Set document direction and language
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getProductName = (englishName) => {
    if (language === 'ar' && productNamesAr[englishName]) {
      return productNamesAr[englishName];
    }
    return englishName;
  };

  const getCategoryName = (englishName) => {
    if (language === 'ar' && categoryNamesAr[englishName]) {
      return categoryNamesAr[englishName];
    }
    return englishName;
  };

  const getCutType = (englishName) => {
    if (language === 'ar' && cutTypesAr[englishName]) {
      return cutTypesAr[englishName];
    }
    return englishName;
  };

  const getPackagingOption = (englishName) => {
    if (language === 'ar' && packagingOptionsAr[englishName]) {
      return packagingOptionsAr[englishName];
    }
    return englishName;
  };

  const getDescription = (englishDesc) => {
    if (language === 'ar' && productDescriptionsAr[englishDesc]) {
      return productDescriptionsAr[englishDesc];
    }
    return englishDesc;
  };

  const getWeight = (englishWeight) => {
    if (language === 'ar' && weightTranslationsAr[englishWeight]) {
      return weightTranslationsAr[englishWeight];
    }
    return englishWeight;
  };

  const getSpecKey = (englishKey) => {
    if (language === 'ar' && specificationKeysAr[englishKey]) {
      return specificationKeysAr[englishKey];
    }
    // Convert camelCase to readable format
    return englishKey.replace(/([A-Z])/g, ' $1').trim();
  };

  const getSpecValue = (englishValue) => {
    if (language === 'ar' && specificationValuesAr[englishValue]) {
      return specificationValuesAr[englishValue];
    }
    return englishValue;
  };

  const formatLocalPrice = (price) => {
    if (price === undefined || price === null) return language === 'ar' ? '٠' : '0';
    if (language === 'ar') {
      return formatPriceArabic(price);
    }
    return price.toLocaleString('en-US');
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      toggleLanguage, 
      t, 
      getProductName,
      getCategoryName,
      getCutType,
      getPackagingOption,
      getDescription,
      getWeight,
      getSpecKey,
      getSpecValue,
      formatLocalPrice,
      isRTL: language === 'ar' 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
